<td class="event-td">
  <a
    class="event"
    [routerLink]="[
      '/app/main',
      {
        outlets: {
          navigation: ['event', market?.event?.id],
          content: ['event-markets', market?.event?.id],
        },
      },
    ]">
    <span class="status-indicator" [ngClass]="{ 'ipl-indicator': isInPlay(), 'opl-indicator': !isInPlay() }"></span>&nbsp;
    <span class="text-link">
      <span class="e-name">{{ market?.event?.name }}</span
      >&nbsp;
      @if (isInPlay()) {
        <b class="text-ipl-2">{{ "In-Play" | translate }}</b
        >&nbsp;
      }
    </span>
  </a>
  <span class="comp-name"
    ><span class="cmp-name">({{ market?.competition?.name }})&nbsp;</span>
    @if (!isInPlay()) {
      <span class="ms-time">{{ market.marketStartTime | momentDate }}&nbsp;</span>
    }
    <b *featureFlag="'inPlayMarketIdDebugger'" class="m-id">{{ market?.marketId }}</b>
  </span>
</td>
@let exchangeRate = exRateService.exRate$ | async;
@let exRate = exchangeRate?.RATE ?? 1;
<td class="matched-td">
  {{ market?.totalMatched * exRate | number: "1.0-0" }}
</td>
@if (marketStatus && marketStatus !== "Open") {
  <td
    [ngClass]="{
      'two-st-wrapper': marketRunners.length === 2,
      'four-st-wrapper': marketRunners.length === 4,
    }"
    class="overlay-wrapper h-st-wrapper"
    [colSpan]="marketRunners.length === 2 ? 4 : 6">
    <app-overlay [text]="marketStatus" />
  </td>
} @else {
  @for (runner of marketRunners; track runner) {
    <td
      [class.no-click]="!allowPlacement"
      class="odd-cell"
      app-runner-td
      [market]="market"
      [data]="runner"
      [update]="getRunnerUpdate(runner?.selectionId)"
      side="back"></td>
    <td
      [class.no-click]="!allowPlacement"
      class="odd-cell"
      app-runner-td
      [market]="market"
      [data]="runner"
      [update]="getRunnerUpdate(runner?.selectionId)"
      side="lay"></td>
  }
}
<td class="action-td">
  <div class="actions">
    <button>
      <mat-icon (click)="handleRules(market)" [matTooltip]="'Market Rules' | translate">info</mat-icon>
    </button>
    @if (myMarketsService.myMarkets$ | async; as myMarkets) {
      @let marketExists = myMarkets.has(market?.marketId);
      @let marketAddedManually = myMarkets.get(market?.marketId)?.source === "manual";
      @if (marketExists && marketAddedManually) {
        <button (click)="removeFromMyMarkets()">
          <mat-icon color="warn" [matTooltip]="'Remove from My Market' | translate">cancel</mat-icon>
        </button>
      }
      @if (!marketAddedManually) {
        <button [disabled]="marketExists" (click)="addToMyMarkets()">
          <mat-icon [matTooltip]="'Add to My Market' | translate" [matTooltipDisabled]="marketExists">add_circle</mat-icon>
        </button>
      }
    }
  </div>
</td>
